// react and js
import { React, useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

// mui
import {
  DialogTitle,
  DialogContent,
  Typography,
  Box,
} from "@mui/material";

// components
import ModalDialog from "../../components/ModalDialog";

// hooks

// layouts
 
// pages

// theme

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function DialogueDistributionUnavailable() {
  // ----------------------------------------------------------------------
  // Properties
  // ----------------------------------------------------------------------
  const { t } = useTranslation();

  // eslint-disable-next-line
  const [open, setOpen] = useState(true);

  const descriptionElementRef = useRef(null);
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const [scroll] = useState("paper");

  return (
    <ModalDialog
      open={Boolean(true)}
      scroll={scroll}
      outlet={
        <>
          <DialogTitle
            id="dialog-title"
            sx={{
              background: "#F2F2F2",
              textTransform: "none",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              alignContent: "center",
              py: 1,
              pr: 1,
            }}
          >
            <Typography variant="contentBig">
              {t("distributionTickData.dialogues.distributionUnavailableTitle")}
            </Typography>
          </DialogTitle>

          <DialogContent
            dividers
            sx={{
              background: "#F2F2F2",
              borderTop: "1px solid #C8C8C8",
              borderBottom: "1px solid #C8C8C8",
            }}
          >
            <Box sx={{ mb: 0 }}>
              <Typography variant="contentMiddle">
                {t("distributionTickData.dialogues.distributionUnavailableBody")}
              </Typography>
            </Box>
          </DialogContent>
        </>
      }
    />
  );
}
